import React, { useState } from "react";
import { nanoid } from 'nanoid';

import { Link } from "@material-ui/core";

import useStyleRCard from "../styles/useStyleRcard";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

import FacebookIcon from "@material-ui/icons/Facebook";
import LanguageIcon from "@material-ui/icons/Language";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";

const randomImage = () => {
  // 1279365 - Architecture and Construction
  // 219941 - Architecture, Buildings, Spaces
  // 504554 - found typography
  let urlo =
    "https://source.unsplash.com/collection/1279365/416x230/?sig=" +
    Math.floor(Math.random() * 300);
  return urlo;
};

//export default function RCard(props) {
const RCard = (props) => {
  const classes = useStyleRCard();
  const { history } = props; //Importo history dal props

  //const [items, setItems] = useState(RData);
  const [items, setItems] = useState(JSON.parse(localStorage.getItem("tags")));

  let item = props.ricerca;
  let abs = item.Abstract.ita;
  let absE = item.Abstract.eng;

  let avatarColor = "";

  switch (item.Tipologia.abbreviazione) {
    case "PE":
      avatarColor = classes.avatarRed;
      break;
    case "PN":
      avatarColor = classes.avatarIndigo;
      break;
    case "PNF":
      avatarColor = classes.avatarTeal;
      break;
    case "PCS":
      avatarColor = classes.avatarGrey;
      break;
    case "PR":
      avatarColor = classes.avatarYellow;
      break;

    default:
      avatarColor = classes.avatarRed;
      break;
  }

  //****************************************************************************
  //Uso le parole chiave per selezionare le ricerche
  //****************************************************************************
  const handleTopicEvent = (event) => {
    //console.log("parola chiave scelta -> " + event.target.textContent);


    props.tag(event.target.textContent);

    //uso filter su TUTTI i record (items) e cerco in Parole_Chiave la stringa passatami dal click nella Card
    //escludendo il cancelletto che mi arriva '.substring(1,event.target.textContent.length-1)'
    const findTags = items.filter((tag) => {
      return tag.Parole_Chiave.includes(event.target.textContent.substring(1, event.target.textContent.length));
    });

    props.settags(findTags); //utilizzo l'Hook che mi è arrivato in props in modo
    //da riempire l'array ricerche che utilizzo per visualizzare le Card

    //console.log("findTags");
    //console.log(findTags);
  };

  //****************************************************************************
  // Funzione per gestire la presenza sia dell'Array Media che l'eventuale
  // presenza del primo elemento 'immagine'
  //****************************************************************************
  const trueImage = () => {
    // ho l'Array Media con qualcosa e il primo elemento è 'immagine'
    if (item.Media.length > 0 && item.Media[0].cosa === "immagine") {
      return (
        <CardMedia
          onClick={() => history.push(`/${item.id}`)}
          className={classes.media}
          image={item.Media[0].link}
          title={item.acronimo}
          alt={item.acronimo}
        />
      );
    } else if (
      (item.Media.length > 0 && item.Media[0].cosa !== "immagine") ||
      !item.Media.length
    ) {
      // ho l'array Media con qualcosa e il primo elemento NON è 'immagine' OPPURE MEDIA è vuoto
      return (
        <CardMedia
          onClick={() => history.push(`/${item.id}`)}
          className={classes.media}
          image={randomImage()}
          title={item.acronimo}
          alt={item.acronimo}
        />
      );
    }
  };

  return (
    <>
      <Card className={classes.root} key={item.id}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe" className={avatarColor}>
              {item.Tipologia.abbreviazione}
            </Avatar>
          }
          title={item.acronimo}
          subheader={item.anno_di_avvio}
          onClick={() => history.push(`/${item.id}`)}
          className={classes.header}
        />
        {/* gestisco l'immagine della ricerca chiamando trueImage() */}
        {trueImage()}

        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            {/* verifico che ci sia un commento in italiano, altrimenti lo inserisco in Inglese*/}
            {abs ? abs.slice(0, 250) : absE.slice(0, 250)}...
          </Typography>
        </CardContent>
        <CardContent>
          <Typography color="textSecondary" component="span">
            <ul className={classes.ulla}>
              {item.Parole_Chiave.map((parole) => (
                <Link color="inherit" onClick={handleTopicEvent}>
                  <>
                    <li className={classes.topic} key={nanoid()}>
                      #{parole}
                    </li>
                    &nbsp;
                  </>
                </Link>
              ))}
            </ul>
          </Typography>
        </CardContent>
        <CardActions disableSpacing>
          {item.web && (
            <IconButton aria-label="Link web" href={item.web}>
              <LanguageIcon />
            </IconButton>
          )}
          {item.Media.map((media) => {
            switch (media.cosa) {
              case "facebook":
                return (
                  <IconButton aria-label="facebook" href={media.link} key={nanoid()}>
                    <FacebookIcon />
                  </IconButton>
                );
              //break;
              case "twitter":
                return (
                  <IconButton aria-label="twitter" href={media.link} key={nanoid()}>
                    <TwitterIcon />
                  </IconButton>
                );
              //break;
              case "instagram":
                return (
                  <IconButton aria-label="intagram" href={media.link} key={nanoid()}>
                    <InstagramIcon />
                  </IconButton>
                );
              //break;
              default:
                return null;
            }
          })}
        </CardActions>
      </Card>
    </>
  );
};

export default RCard;
